import React from "react";
import PropTypes from "prop-types";

import { H1, H2, H3, H4, Paragraph } from "components/core/Typography";
import { Image } from "@sparefoot/react-commons";
import Link from "components/core/Link/Link";
import MarkdownContent from "components/molecules/MarkdownContent/MarkdownContent";

import "./PSPMarkdownContent.scss";

const markdownContentMap = (additionalProps) => ({
	h1: (props) => (
		<H1
			size="large"
			weight="extraBold"
			{...additionalProps?.heading}
			{...props}
		/>
	),
	h2: (props) => (
		<H2
			size="large"
			weight="extraBold"
			{...additionalProps?.heading}
			{...props}
		/>
	),
	h3: (props) => (
		<H3
			size="medium"
			weight="extraBold"
			{...additionalProps?.heading}
			{...props}
		/>
	),
	h4: (props) => (
		<H4
			size="medium"
			{...additionalProps?.heading}
			{...props}
		/>
	),
	p: (props) => (
		<Paragraph
			size="standard"
			weight="regular"
			color="gray"
			{...additionalProps?.paragraph}
			{...props}
		/>
	),
	a: (props) => (
		<Link
			inheritFont
			{...additionalProps?.anchor}
			{...props}
		/>
	),
	img: (props) => <Image {...props} />,
	ul: ({ ordered, ...props }) => (
		<ul
			className="psp-markdown-ul-padding"
			{...additionalProps?.ul}
			{...props}
		/>
	),
	ol: ({ ordered, ...props }) => (
		<ol
			className="psp-markdown-ol"
			{...additionalProps?.ol}
			{...props}
		/>
	)
});

// This is only a text component, use it for adding text into any PSP module
// It needs to be imported in a PSP module
export default function PSPMarkdownContent({ content, additionalProps,className=""}) {
	const markdownComponents = markdownContentMap(additionalProps);
	return (
		<MarkdownContent
			components={markdownComponents}
			content={content}
			className={className}
		/>
	);
}

PSPMarkdownContent.propTypes = {
	content: PropTypes.string.isRequired,
	additionalProps: PropTypes.object,
	className: PropTypes.string
};
